import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PaywallGuard } from './PaywallGuard';
import { ExpiredLockScreen } from './ExpiredLockScreen';

// Routes an expired user CAN reach — needed so they can actually renew.
// Pricing + payment success + the global subscription confirmation page
// must remain navigable. Everything else (dashboard, portfolios, reports,
// settings, insurance, tax-harvesting, wallet, etc.) is hard-locked
// behind the ExpiredLockScreen.
const EXPIRED_USER_ALLOWED_PATHS = [
  '/pricing',
  '/payments',
  '/payment-success',
  '/subscription-success',
];

export const ProtectedRoute = ({ children }) => {
  const { user, loading, isExpired } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#F7F7F5' }}>
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto" style={{ borderColor: '#1B4332' }}></div>
          <p className="mt-4" style={{ color: '#57534E' }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Iter-121: expired users get the hard lockout — no access to any app
  // page except the renewal flow itself. Sub-users of an expired admin
  // are handled separately by SubUserLockout (inside PaywallGuard).
  if (isExpired && !user?.is_sub_user) {
    const onRenewalPath = EXPIRED_USER_ALLOWED_PATHS.some(
      (p) => location.pathname.startsWith(p),
    );
    if (!onRenewalPath) {
      return <ExpiredLockScreen />;
    }
  }

  return <PaywallGuard>{children}</PaywallGuard>;
};
